<template>
  <div class="uni-real-test-start">
    <i class="iconfont iconfanhui" @click="$router.go(-1)" style="font-size: 30px;position: absolute;margin: 10px 0 0 20px"></i>
    <div class="container">
      <h1 class="title">{{ dataText.title? dataText.title : '考前模拟' }}</h1>
      <div class="real-content">
        <div class="img-box"></div>
        <div style="flex: 1">
          <div class="test-info">
            <p class="row">
              <span>
                考试总时长：
                <em class="primary" style="font-style: normal"
                  >{{ dataText.duration }}分钟</em
                >
              </span>
              <span>共计：{{ dataText.question_num }}道题</span>
            </p>
            <p class="row">
              <span>总分：{{ dataText.total_score }}分</span>
              <span>合格分：{{ dataText.pass_score }}分</span>
            </p>
          </div>
          <div class="test-notice">
            <p class="tit">题型介绍：</p>
            <div style="white-space: pre-line;">
              <p v-html="dataText.introduction"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="pab20" style="text-align: center">
        <el-button
          type="primary"
          class="start-btn"
          v-if="type == 3"
          @click="startExam(0)"
          >开始练习</el-button
        >
        <el-button type="primary" class="start-btn" @click="startExam(1)"
          >开始考试</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { TestInfo, QuestionTest } from "@/api/realTest";
import { removeStore } from "@/utils/localStorage";
import { jsToFormData } from "@/utils/func";
export default {
  name: "LearnTest",
  data() {
    return {
      dataText: '',
      test_id: this.$route.query.test_id,
      exam_id: this.$route.query.examId,
      course_id: this.$route.query.course_id,
      type: this.$route.query.type, //  3 练习模式考试模式, 2 模拟考试
      typeName: ["单选题", "多选题", "判断题", "填空题"],
      paperModeHasKaoshi: true,
      paperModeHasLianxi: true,
    };
  },
  watch: {
    $route() {
      this.test_id = this.$route.query.test_id;
      this.exam_id = this.$route.query.examId;
      this.course_id = this.$route.query.course_id;
      this.type = this.$route.query.type;
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 清除数据
    /*clearData() {
      removeStore("formData");
      removeStore("indexNum");
      removeStore("cuntNumber");
      removeStore("isFullScreen");
      removeStore("isFaceNumber");
      removeStore("isFaceVideo");
    },*/
    async getData() {
      const params = {
        id: this.test_id || this.exam_id || 1,
        type: this.type,
      };
      const res = await TestInfo(params);
      if (res.code === 200) {
        this.dataText = res.result;
        if (this.dataText.introduction) {
          this.content = this.dataText.introduction.replace(/\n/g, "<br>");
        }
      }
    },

    startExam(is_exam) {
      //this.clearData();
      if(!is_exam) {
        this.$router.push({
          // name: "smartPractice",
          name: "smartPractice",
          query: {
            test_id: this.test_id,
            course_id: this.course_id,
            // id: this.test_id,
          },
        });
        return
      }
      this.$router.push({
        name: "onlineTest",
        query: {
          typeTest: this.type,
          test_id: this.test_id,
          course_id: this.course_id,
          exam_id: this.exam_id
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.uni-real-test-start {
  padding: $sideMargin;
  padding-bottom: 0;
  min-height: $menuH;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: #fff;
    padding: 0 150px;
    min-height: inherit;
  }

  .real-content {
    display: flex;
    align-items: center;
    border-top: 1px solid $grayBorder;
    padding-top: 60px;
    margin-top: 40px;

    .img-box {
      width: 350px;
      height: 330px;
      margin-right: 40px;
      overflow: hidden;
      @include themeIcon("paper");
    }
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }

  .start-btn {
    @include uni-primary-btn(123px, 34px);
    @include linearGradient("btn-start", "btn-end");
    margin-top: 75px;
  }

  // .repeat-btn {
  //   @include uni-primary-btn(123px, 34px);
  //   background: #fff;
  //   color: $textColor;
  //   border: 1px solid $grayLight;
  //   margin-right: 98px;
  // }

  .test-info {
    .row {
      height: 30px;
      line-height: 30px;

      span {
        display: inline-block;
        width: 200px;
      }
    }
  }

  .test-notice {
    border-top: 1px solid $grayBorder;
    line-height: 30px;
    margin-top: 40px;

    .tit {
      margin-top: 30px;
    }
  }
}
</style>
